/**
 * Gateway client for KAI-powered image enhancement suggestions.
 * ${REACT_APP_AI_BUILDER_URL}/api/ai/image/*
 */
const BASE = process.env.REACT_APP_AI_BUILDER_URL || "http://localhost:4000";

function headers() {
  return {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    merchantId: localStorage.getItem("merchantId") || "",
    sessionId: localStorage.getItem("sessionId") || "",
  };
}

async function call(path, body) {
  const res = await fetch(`${BASE}/api${path}`, {
    method: "POST",
    cache: "no-store",
    headers: headers(),
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = new Error(`Image AI API error: ${res.status}`);
    err.status = res.status;
    try {
      err.body = await res.json();
      if (err.body?.error) {
        err.message = err.body.error;
      }
    } catch {
      /* ignore */
    }
    throw err;
  }
  return res.json();
}

export async function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (typeof result === "string") {
        const base64 = result.split(",")[1] || result;
        resolve(base64);
      } else {
        reject(new Error("Could not read file"));
      }
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export const imageStudioClient = {
  /**
   * KAI analyzes the image and returns filter adjustments + optional alt text.
   * @param {{ imageBase64: string, mimeType?: string, context?: string, aspectPreset?: string }} params
   */
  enhance: (params) => call("/ai/image/enhance", params),

  /**
   * Remove background server-side; returns PNG base64 with transparency.
   */
  removeBackground: (params) => call("/ai/image/remove-background", params),

  /**
   * Suggest alt text for accessibility / SEO.
   */
  suggestAltText: (params) => call("/ai/image/suggest-alt", params),
};
